<script>
    export default {
        data() {
            return {
                isActive: false
            }
        },
    }
</script>
